var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.283 9.87291C10.878 10.2781 10.4725 10.6833 10.0738 11.0955C9.96481 11.2088 9.87256 11.2327 9.73985 11.1571C9.4779 11.0129 9.19818 10.8961 8.94608 10.7385C7.77097 9.99323 6.78628 9.03517 5.91407 7.9573C5.48142 7.42184 5.09613 6.8481 4.82726 6.20276C4.773 6.0725 4.78286 5.98649 4.88844 5.8801C5.29395 5.48534 5.68911 5.08014 6.08772 4.67494C6.64321 4.11164 6.64321 3.45289 6.08427 2.88611C5.76755 2.56344 5.45083 2.24773 5.13362 1.92506C4.80654 1.59544 4.48341 1.26233 4.15239 0.936182C3.61761 0.410668 2.95014 0.410668 2.41882 0.939663C2.00936 1.34436 1.61814 1.76 1.20227 2.15824C0.816974 2.52565 0.623095 2.9756 0.582148 3.50061C0.517522 4.35576 0.725215 5.16267 1.01825 5.94871C1.61814 7.57596 2.5313 9.02125 3.63833 10.3467C5.13362 12.139 6.91899 13.557 9.00726 14.5802C9.94755 15.0401 10.9219 15.394 11.9816 15.4522C12.7107 15.4935 13.3446 15.308 13.8518 14.7348C14.1996 14.3435 14.5913 13.986 14.9593 13.6122C15.5044 13.0558 15.5079 12.3832 14.9662 11.8338C14.319 11.1775 13.6683 10.5252 13.0171 9.87291C12.4823 9.34094 11.8148 9.34094 11.283 9.87291Z",
    fill: "#F7B500",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUs);
export default __webpack_public_path__ + "static/media/call_us.d8d7c23637ca4da8232623bcc2eb5f79.svg";
export { ForwardRef as ReactComponent };